import {
  VantifyProxyResponse,
  vantifyRequest,
} from 'integrations-vantify-api-client';
import { VantifyAuth, VantifyQuery } from '../common';
import {
  ServiceProviderPriority,
  ServiceProviderPriorityListResponse,
} from './types';

const DEFAULT_LIMIT = 30;

/**
 * Get priorities for a specific service provider by automatically handling pagination.
 * Fetches all priorities by making multiple API calls if needed.
 */
export async function getServiceProviderPriorities(
  auth: VantifyAuth,
  serviceProviderId: number,
  query?: VantifyQuery
): Promise<VantifyProxyResponse<ServiceProviderPriorityListResponse>> {
  const allPriorities: ServiceProviderPriority[] = [];
  let currentPage = 1;
  let totalPages = 1;
  let totalCount = 0;

  do {
    const response =
      await vantifyRequest<ServiceProviderPriorityListResponse>({
        method: 'GET',
        pathname: `serviceproviders/${serviceProviderId}/priorities`,
        query: {
          order: 'name',
          ...query,
          page: currentPage,
          limit: DEFAULT_LIMIT,
        },
        auth,
      });

    const data = response.data;

    allPriorities.push(...data.priorities);
    totalPages = data.pages;
    totalCount = data.count;

    currentPage++;
  } while (currentPage <= totalPages);

  return {
    status: 200,
    statusText: 'OK',
    data: {
      priorities: allPriorities,
      count: totalCount,
      pages: totalPages,
      limit: DEFAULT_LIMIT,
      page: 1,
    },
  };
}
